export default __webpack_public_path__ + "static/media/logo-hkms.ea992684.png";